import { ThreePlanogram } from "../store/types";
import { PlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { Product } from "./Product";

interface Props {
  products: PlanogramItem[];
  three: ThreePlanogram;
}

export const Products = ({ products, three }: Props) => {
  return products.map((product) => (
    <Product key={product.uniqueId} product={product} three={three} />
  ));
};
